'use strict';

var _ = require('lodash');
var ConstraintValidationService = function ConstraintValidationService() {
  var SUPPORTED_OPERATIONS = {
    '<': function _(a, b) {
      return a < b;
    },
    '>': function _(a, b) {
      return a > b;
    },
    'isBetween': function isBetween(a, b, c) {
      return a >= b && a <= c;
    },
    'gtInv': function gtInv(a, b) {
      return a > -b;
    },
    'ltInv': function ltInv(a, b) {
      return -a < b;
    },
    '>=': function _(a, b) {
      return a >= b;
    }
  };
  function validate(value, constraint, allActions) {
    var valid = true;
    if (!_.isNil(value) && !_.isUndefined(constraint)) {
      var operatorFunction = SUPPORTED_OPERATIONS[constraint.operator];
      var params = constraint.params;
      var refField = constraint.field;
      if (refField) {
        var lastRefAction = _.findLast(allActions, ['field', refField]);
        if (!_.isUndefined(lastRefAction)) {
          valid = _.isNaN(parseFloat(lastRefAction.value)) || operatorFunction(parseFloat(value), parseFloat(lastRefAction.value));
        }
      } else {
        if (_.isArray(params)) {
          valid = operatorFunction(parseFloat(value), params[0], params[1]);
        }
      }
    }
    return valid;
  }
  return {
    validate: validate
  };
};
ConstraintValidationService.$inject = [];
module.exports = ConstraintValidationService;